export const FETCH_PRODUCTS_BY_GROUP = "FETCH_PRODUCTS_BY_GROUP";
export const FETCH_PRODUCTGROUPS = "FETCH_PRODUCTGROUPS";
export const FETCH_PRODUCTGROUPS_BY_SUPPLIER =
  "FETCH_PRODUCTGROUPS_BY_SUPPLIER";
export const FETCH__SUPPLIERS = "FETCH__SUPPLIERS";
export const FETCH_PRODUCTGROUPS_FARMER = "FETCH_PRODUCTGROUPS_FARMER";
